const XXS = 320;
const XS = 576;
const SM = 768;
const MD = 1023;
const LG = 1200;
const XL = 1400;
const XXL = 1650;

/**
 * Duplicates sizes from file _mixins.scss
 * @see public/wp-content/themes/comparison/assets/scss/common/_mixins.scss
 */
class DeviceSizes {
	static get XXS() {
		return XXS;
	}

	static get XS() {
		return XS;
	}

	static get SM() {
		return SM;
	}

	static get MD() {
		return MD;
	}

	static get LG() {
		return LG;
	}

	static get XL() {
		return XL;
	}

	static get XXL() {
		return XXL;
	}
}

export default DeviceSizes;
